import { FC, useContext, useEffect, useState } from "react";
import { format, parseISO, isValid, parse } from "date-fns";

import { DownloadZipResponseType } from "src/pages/dashboard/types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";

import { CaseInformationProps, DownloadBenefitPDFResponseTypeApi } from "./types";
import { downloadPdfFile } from "src/helpers/downloadFile";
import { CASE_REVIEW_TYPES } from "src/constants/cases";
import { AuthContext } from "src/context/authContext";




const CaseInformation: FC<CaseInformationProps> = ({ caseObject }): JSX.Element => {

  const [enabledButton, setEnabledButton] = useState<boolean>(false);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { isManufacturer } = useContext(AuthContext);

  const {
    data: downloadCaseData, error: downloadCaseError, mutate: downloadRequestForm, removeErrorAndData: clearRequestFileData
  } = useFetch<DownloadZipResponseType>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadCaseData || downloadCaseError) {
      if (downloadCaseData) {
        const { response } = downloadCaseData;
        downloadPdfFile(response, `case_${caseObject.case_information.id}_reports.pdf`);
      }
      hideLoader();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadCaseData, downloadCaseError]);

  const downloadFileByCaseId = () => {
    // OpenForm Enrollment
    if (downloadCaseData || downloadCaseError) clearRequestFileData();
    setLoader();

    if (caseObject && caseObject.case_information)
      downloadRequestForm({}, {}, { ref_id: caseObject.case_information.id, type: `${caseObject.case_information.product.toLowerCase().replace("furoscix", "").trim().replace(/\s/g, "-")}-${caseObject.case_information.category === 'qs2' ? 'qs2' : 'request'}` , ref_type: 'Case', skip_pi: isManufacturer,  });
  };





  //////////////////////////////////////////////////Download PDF Benefits////////////////////////////////////////////
  const {
    data: downloadBenefitCaseData, error: downloadBenefitCaseError,
    removeErrorAndData: clearBenefitRequestFileData, mutate: downloadBenefitRequestForm,
  } = useFetch<DownloadBenefitPDFResponseTypeApi>(APIEndpoints.DOWNLOAD_REQUEST_FORM);

  useEffect(() => {
    if (downloadBenefitCaseData || downloadBenefitCaseError) {
      if (downloadBenefitCaseData) {
        const { response, report_name } = downloadBenefitCaseData;
        downloadPdfFile(response, `${report_name}`);
      }
      hideLoader();
      setEnabledButton(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadBenefitCaseData, downloadBenefitCaseError]);

  const downloadBenefitClickOnPdf = (refId: number, benefitType: string) => {
    if (downloadBenefitCaseData || downloadBenefitCaseError) clearBenefitRequestFileData();
    setLoader();
    setEnabledButton(true);
    downloadBenefitRequestForm({}, {}, { ref_id: refId, type: 'investigation', ref_type: 'Insurance', benefit_type: benefitType, });
  };


  return (
    <>
      <div className="card mb-4">
        <div className="card-header">
          <h1 className="m-0">Case Information</h1>
        </div>
        <div className="card-body">
          <div className="row">

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Created:</p>
              </div>
              <div className="col-6">
                <p>{caseObject && caseObject.case_information ? caseObject.case_information.created : "N/A"}</p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Product:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.product : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Shipment Date:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.shipment_date : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Benefits Type:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.benefits_type : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Review Type:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information && caseObject.case_information.review_type ? 
                    CASE_REVIEW_TYPES.find((item) => item.value === caseObject.case_information.review_type)?.name
                  : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Condition:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.condition || "N/A" : "N/A"}
                </p>
              </div>
            </div>
          </div>

          

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Quantity:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.quantity : "N/A"}
                </p>
              </div>
            </div>
          </div>
           {caseObject.case_information.product === "Furoscix ReadyFlow Autoinjector" &&
            <>
           <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Frequency:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.frequency_of_use : "N/A"}
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Daily Dose:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.daily_dose : "N/A"}
                </p>
              </div>
            </div>
          </div>
          </>}
          <div className="col-lg-6 col-md-6 col-12">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Supervising MD Name:</p>
              </div>
              <div className="col-6">
                <span>{caseObject && caseObject.case_information ? caseObject.case_information.supervising_md_firstname : 'N/A'}</span>
                {" "}
                <span>{caseObject && caseObject.case_information ? caseObject.case_information.supervising_md_lastname : 'N/A'}</span>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Refills:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject ? caseObject.refills : 0}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Diagnosis Code:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information && caseObject.case_information.diagnosis_code ? caseObject.case_information.diagnosis_code.split(",").join(", ") : "N/A"}
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="row">
              <div className="col-6 text-end px-3">
                <p>Note:</p>
              </div>
              <div className="col-6">
                <p>
                  {caseObject && caseObject.case_information ? caseObject.case_information.note : "N/A"}
                </p>
              </div>
            </div>
          </div>
            {/* <div className="col-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Site of Care:</p>
                </div>
                <div className="col-6">
                  <p>
                    {caseObject && caseObject.case_information && caseObject.case_information.soc && caseObject.case_information.soc.length > 0 ?
                      caseObject.case_information.soc[0].value : "N/A"
                    }
                  </p>
                </div>
              </div>
            </div> */}
            {/* <div className="col-12 col-md-6"></div> */}

            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Anticipated Date of Service:</p>
                </div>
                <div className="col-6">
                  <p>
                    {caseObject && caseObject.case_information && caseObject.case_information.scheduled_date_of_service && isValid(new Date(caseObject.case_information.scheduled_date_of_service)) ? 
                      format(parse(caseObject.case_information.scheduled_date_of_service, "yyyy-MM-dd", new Date()), "MM/dd/yyyy")
                    : "N/A"}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Directions:</p>
                </div>
                <div className="col-6">
                  <p>
                    {caseObject && caseObject.case_information ? caseObject.case_information.directions : "N/A"}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Written Date:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.case_information ? caseObject.case_information.written_date : "N/A"}</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Auto X-fer to Pharmacy:</p>
                </div>
                <div className="col-6">
                  <p>
                    {caseObject && caseObject.case_information ? caseObject.case_information.auto_xfer : "N/A"}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p className="mb-0"> Prescription Start Form:</p>
                </div>
                <div className="col-6">
                  <p>
                    <i className="text-danger bi bi-file-pdf fw-bold"></i>
                    <button
                        onClick={downloadFileByCaseId}
                        className="btn btn-link align-baseline p-0 link-offset-0-hover link-underline link-underline-opacity-0 link-underline-opacity-75-hover"
                    >
                      Download
                    </button>
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              {/* <div className="row">
                <div className="col-6 text-end px-3">
                  <p className="mb-0">Benefits Investigations:</p>
                </div>
                <div className="col-6">
                  {
                    caseObject && caseObject.case_information && typeof caseObject.case_information.benefit_investigation !== 'string' ?
                        caseObject.case_information.benefit_investigation.map((benefit) => (
                            benefit.completed_benefits.map((item, index) => (
                                <p key={index} className="d-flex gap-1 m-0">
                                  <i className="text-danger bi bi-file-pdf fw-bold"></i>
                                  <button
                                      className="btn btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 align-baseline text-start"
                                      onClick={() => downloadBenefitClickOnPdf(benefit.id, item.benefit_type)}
                                      disabled={enabledButton}>
                                    {item.download_title}
                                  </button>
                                </p>
                            ))
                        ))
                    : 'N/A'
                  }
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h1 className="m-0">Current and Prior Diuretics</h1>
        </div>
        <div className={"card-body"}>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Furosemide:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.prior_diuretics && caseObject.prior_diuretics.furosemide_dosage ? caseObject.prior_diuretics.furosemide_dosage : "N/A"}</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Result of Use:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.prior_diuretics && caseObject.prior_diuretics.furosemide_result_of_use ? caseObject.prior_diuretics.furosemide_result_of_use : "N/A"}</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              {caseObject && caseObject.prior_diuretics && caseObject.prior_diuretics.furosemide_result_of_use ? (
                  caseObject.prior_diuretics.furosemide_result_of_use === "Resulted in hospitalization" && caseObject.prior_diuretics.furosemide_hospitalization_date ? (
                      <div className="row">
                        <div className="col-6 text-end px-3">
                          <p>Hospitalization Date:</p>
                        </div>
                        <div className="col-6">
                          <p>{format(parseISO(caseObject.prior_diuretics.furosemide_hospitalization_date.trim()), "MM/dd/yyyy") || "N/A"}</p>
                        </div>
                      </div>
                  ) : caseObject.prior_diuretics.furosemide_result_of_use === "Other" ? (
                      <div className="row">
                        <div className="col-6 text-end px-3">
                          <p>Other:</p>
                        </div>
                        <div className="col-6">
                          <p>{caseObject.prior_diuretics.furosemide_other || "N/A"}</p>
                        </div>
                      </div>
                  ) : null
              ) : null}

            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Torsemide:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.prior_diuretics && caseObject.prior_diuretics.torsemide_dosage ? caseObject.prior_diuretics.torsemide_dosage : "N/A"}</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Result of Use:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.prior_diuretics && caseObject.prior_diuretics.torsemide_result_of_use ? caseObject.prior_diuretics.torsemide_result_of_use : "N/A"}</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              {caseObject && caseObject.prior_diuretics && caseObject.prior_diuretics.torsemide_result_of_use  ? (
                  caseObject.prior_diuretics.torsemide_result_of_use === "Resulted in hospitalization" && caseObject.prior_diuretics.torsemide_hospitalization_date ? (
                      <div className="row">
                        <div className="col-6 text-end px-3">
                          <p>Hospitalization Date:</p>
                        </div>
                        <div className="col-6">
                          <p>{format(parseISO(caseObject.prior_diuretics.torsemide_hospitalization_date.trim()), "MM/dd/yyyy") || "N/A"}</p>
                        </div>
                      </div>
                  ) : caseObject.prior_diuretics.torsemide_result_of_use === "Other" ? (
                      <div className="row">
                        <div className="col-6 text-end px-3">
                          <p>Other:</p>
                        </div>
                        <div className="col-6">
                          <p>{caseObject.prior_diuretics.torsemide_other || "N/A"}</p>
                        </div>
                      </div>
                  ) : null
              ) : null}


            </div>
          </div>

          <div className="row">

            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Bumetanide:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.prior_diuretics && caseObject.prior_diuretics.bumetanide_dosage ? caseObject.prior_diuretics.bumetanide_dosage : "N/A"}</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <div className="row">
                <div className="col-6 text-end px-3">
                  <p>Result of Use:</p>
                </div>
                <div className="col-6">
                  <p>{caseObject && caseObject.prior_diuretics && caseObject.prior_diuretics.bumetanide_result_of_use ? caseObject.prior_diuretics.bumetanide_result_of_use : "N/A"}</p>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6">
              {caseObject?.prior_diuretics?.bumetanide_result_of_use ? (
                caseObject.prior_diuretics.bumetanide_result_of_use === "Resulted in hospitalization" && caseObject.prior_diuretics.bumetanide_hospitalization_date ? (
                  <div className="row">
                    <div className="col-6 text-end px-3">
                      <p>Hospitalization Date:</p>
                    </div>
                    <div className="col-6">
                      <p>{format(parseISO(caseObject.prior_diuretics.bumetanide_hospitalization_date.trim()), "MM/dd/yyyy") || "N/A"}</p>
                    </div>
                  </div>
                ) : caseObject.prior_diuretics.bumetanide_result_of_use === "Other" ? (
                  <div className="row">
                    <div className="col-6 text-end px-3">
                      <p>Other:</p>
                    </div>
                    <div className="col-6">
                      <p>{caseObject.prior_diuretics.bumetanide_other || "N/A"}</p>
                    </div>
                  </div>
                ) : null
              ) : null}
            </div>
          </div>

        </div>
        <div className="card m-3 mt-0">
          <div className="card-header">
            <h1 className="m-0">Lab Values</h1>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <p>Estimated Creatinine Clearance:</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {caseObject?.prior_diuretics?.lab_values?.creatinine_clearance
                          ? `${caseObject.prior_diuretics.lab_values.creatinine_clearance} mL/min`
                          : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="row">
                  <div className="col-6 text-end px-3">
                    <p>Estimated Glomerular Filtration Rate (eGFR):</p>
                  </div>
                  <div className="col-6">
                    <p>
                      {caseObject?.prior_diuretics?.lab_values?.glomerular_filtration
                          ? `${caseObject.prior_diuretics.lab_values.glomerular_filtration} mL/min/1.73 m²`
                          : "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseInformation;
